import { useState, useEffect } from "react";
// import "./styles/PanelConfig.css";
import Search from "../generales/Search";
import Modal from "react-modal";
// import Action from "../Action";
import Action from "../Action";
import LoadSimple from "../LoadSimple";
import TableWorkFlow from "./Triggers/TableWorkFlow";
// import InfoPortafolio from "./Criticidad/InfoPortafolio";
import Paginador from "../generales/Paginador";
// import ModalCreateTrigger from "./Triggers/ModalCreateTrigger";
import ModalCreateWorkFlow from "./Workflow/ModalCreateWorkFlow";
// import ImportInfo from "./Brands/ImportInfo";
import { capitalizeFirstLetter } from "../../utils/utils";
import { lang } from "../generales/traduction";
import { permisos_codigo_id } from "../generales/GroupsId";
const CreateCisModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "90%",
    padding: "20px",
  },
};
const CreateCisModalStyles2 = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "50%",
    padding: "20px",
  },
};

const ImportModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "70%",
    padding: "20px",
  },
};
const PanelWorkFlow = ({ server, languaje, mode, handleShowPopup, userPermissions }) => {
  // const limitList = 200;
  const [limitList, setLimitList] = useState(50);
  const [pageActual, setPageActual] = useState(1);
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const [ImportModalOpen, setImportModalOpen] = useState(false);
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  var dataList = searchTerm === "" ? dataUsers.data : searchResults;
  const [devices, setDevices] = useState({
    data: [],
    loading: true,
    error: null,
  });
  // const startLimit=(searchTerm==='')?((limitList*pageActual)-limitList):0;
  const startLimit = limitList * pageActual - limitList;
  const pages = parseInt(dataList.length / limitList) + 1;
  const [searchResult, setSearchResult] = useState(null);
  const [contRowsSelected, setContRowSelected] = useState(0)
  const [registerIsValid, setRegisterIsValid] = useState(false);
  const [editActive, setEditActive] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataCis, setDataCis] = useState([]);
  const [loadingCis, setLoadingCis] = useState(false);
  const [errorCis, setErrorCis] = useState(null);
  const [cisSelected, setCisSelected] = useState([]);
  const [groupSelected, setgroupSelected] = useState([])
  const [poolRows, setPoolRows] = useState([])
  const [allSelected, setAllSelected] = useState(false);
  const [exportLoading, setExportLoading] = useState(false)
  const [loadingList, setLoadingList] = useState(false)
  const [page, setPage] = useState(true)
  const obtenerFechaActualLocal = () => {
    const ahora = new Date();
    const anio = ahora.getFullYear();
    const mes = String(ahora.getMonth() + 1).padStart(2, "0"); // El mes se cuenta desde 0
    const dia = String(ahora.getDate()).padStart(2, "0");
    const horas = String(ahora.getHours()).padStart(2, "0");
    const minutos = String(ahora.getMinutes()).padStart(2, "0");

    return `${anio}-${mes}-${dia}_${horas}-${minutos}`;
  };
  useEffect(() => {
    setPageActual(1);
  }, [dataList]);
  const handleSearch = (query) => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setSearchResult(`Resultados para: ${query}`);
  };
  const crear = () => {
    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setCreateCisModalOpen(true);
  };
  function closCreateCisModal() {
    setSearchTerm("")
    setEditActive(false);
    setCreateCisModalOpen(false);
    setPage(true)
  }
  const import_info = () => {

    // Aquí puedes realizar la búsqueda usando el valor de 'query'
    // Por ejemplo, puedes actualizar el estado 'searchResult' con los resultados
    setImportModalOpen(true);

  };
  function closeImportModal() {
    setSearchTerm("")
    setImportModalOpen(false);
    setAllSelected(false)
    setPoolRows([])
  }
  const handleChangEdit = (element) => {
    setgroupSelected(element)
    setEditActive(true);
    setCreateCisModalOpen(true)
  };
  useEffect(() => {
    // search_devices();
  }, []);





  const Exportar = (file_type) => {

    let method = 'POST'
    const body = {
      "file_type": file_type,
      "brand_ids": poolRows
    }
    setExportLoading(true)
    const fetchDataPost = async () => {

      try {
        // console.log(localStorage.getItem('access_token'))
        const response = await fetch(server.url + '/api/v1/cassia/brands/export', {
          method: method,
          headers: {
            "Accept": "application/json",
            // 'Content-Type': 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
          body: JSON.stringify(body),
        });
        if (response.ok) {
          // Dependiendo del tipo de archivo, gestionamos el blob y descargamos
          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;

          // Dependiendo del tipo de archivo, nombramos el archivo a descargar
          if (file_type === 'json') {
            link.download = 'Marcas.json';
          } else if (file_type === 'csv') {
            link.download = 'Marcas.csv';
          } else if (file_type === 'excel') {
            link.download = 'Marcas.xlsx'; // Archivo de Excel
          }

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setAllSelected(false)
          setPoolRows([])
          setExportLoading(false);
          handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']), capitalizeFirstLetter((lang[languaje]['descargaFileCompleta'])), '', true)

        } else {
          throw new Error('Error en la solicitud');
        }
      } catch (error) {

      }
    };

    fetchDataPost();

  }

  const handleSelectChange = (e) => {
    setLimitList(e.target.value); setPageActual(1);
  };
  useEffect(() => {
    buscar_cis();
    buscar_host()
  }, []);
  const buscar_cis = () => {
    setLoadingList(true)
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
          "/api/v1/cassia/workflow/",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setLoadingList(false)
          setDataUsers(data1);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const [loadingHost, setLoadingHost] = useState(false);
  const [hosts, setHosts] = useState([]);

  const buscar_host = () => {
    setLoadingHost(true)
    const fetchDataPost = async () => {
      try {
        // console.log(
        //   "http://" +
        //     server.ip +
        //     ":" +
        //     server.port +
        //     "/api/v1/cassia/hosts/"
        // );
        const response = await fetch(
          server.url +
          "/api/v1/cassia/hosts/",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        // console.log(response);
        if (response.ok) {
          const data1 = await response.json();
          setLoadingHost(false)
          //   console.log(data1);
          setHosts(data1.data)
          // setDataUsers(data1);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          //   console.log(data1);
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };

  const [importLoading, setImportLoading] = useState(false);
  return (
    <>
      <div className='head-cis'>
        <div className='title-cis'>
          <Search
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            onSearch={handleSearch}
            dataObject={dataUsers.data}
            setDataObject={setDataUsers}
            searchResult={searchResult}
            setSearchResult={setSearchResult}
            languaje={languaje}
          />
          <div className={"cont-result-registers" + mode}>

            <p style={{ textAlign: "center" }}>
              &nbsp;
              {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados']) + " (" +
                dataList.length +
                ") "
              }
            </p>
          </div>
          <div className="cont-buttons-panel">
            {(loadingHost || loadingList) ? '' :
              <>
                {userPermissions.some(
                  (objeto) => objeto.permission_id === permisos_codigo_id["crear workflow"]
                ) ?
                  <Action
                    disabled={false}
                    origen="Azul"
                    titulo={"+ " + capitalizeFirstLetter(lang[languaje]['nuevoRegistro'])}
                    action={crear}
                  /> : ''}
              </>
            }



          </div>
          {/* <div className="cont-buttons-panel" style={{right:'15%'}}>
                     
                    
                   
                   
                   <Action
                       disabled={false}
                       origen="Cielo"
                       titulo={" "+capitalizeFirstLetter(lang[languaje]['importar'])}
                       action={import_info}
                     />
    
                 </div> */}
        </div>

      </div>
      <div className='cont-cis'>
        <>
          <div className="main-panel-cis">
            <div className="compact-content-portafolio">
              <div className={"content-portafolio-head" + mode}>
                {
                  // (contRowsSelected!=0)?
                  <>
                    {(exportLoading) ? <div className="cont-excels-buttons-portafolio cont-result-registers" style={{ position: 'absolute' }}>{capitalizeFirstLetter(lang[languaje]['descargando'])}. . .</div> :
                      <>
                        {/* {(contRowsSelected==0)?<div className="cont-excels-buttons-portafolio" style={{position:'absolute',background:'#62626233',zIndex:'2'}}></div>:''} */}
                        {/* <div className="cont-excels-buttons-portafolio" style={{position:'absolute'}}>
    <div className="half-excels-buttons-portafolio">
                  
                  <div className="body-half-excels-buttons-portafolio">
                  {
                    
                    <img
              className="img-dwnld-portafolio"
              src={"/iconos/csv_icon.png"}
              name="regresar"
              onClick={()=>Exportar('csv')}
              style={{opacity:(contRowsSelected==0)? '0.3':'1',
                pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
            />
                  }
                  </div>
                  <div className={"top-half-excels-buttons-portafolio"+mode} >
                    {'CSV  '}
                  </div>
                </div>
               <div className="half-excels-buttons-portafolio">
                  
                  <div className="body-half-excels-buttons-portafolio">
                  {
                    
                    <img
              className="img-dwnld-portafolio"
              src={"/iconos/json_icon.png"}
              name="regresar"
              onClick={()=>Exportar('json')}
              style={{opacity:(contRowsSelected==0)? '0.3':'1',
                pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
            />
                  }
                  </div>
                  <div className={"top-half-excels-buttons-portafolio"+mode} >
                    {'JSON'}
                  </div>
                </div>
                <div className="half-excels-buttons-portafolio">
                
                  <div className="body-half-excels-buttons-portafolio">
                  {
                    
                    <img
              className="img-dwnld-portafolio"
              src={"/iconos/xsl_icon.png"}
              name="regresar"
              onClick={()=>Exportar('excel')}
              style={{opacity:(contRowsSelected==0)? '0.3':'1',
                pointerEvents:(contRowsSelected==0)? 'none':'auto'}}
            />
                  }
                  </div>
                  <div className={"top-half-excels-buttons-portafolio"+mode} >
                  {'EXCEL'}
                  </div>
                </div>
           </div> */}
                      </>
                    }
                  </>
                  // :''
                }
              </div>
              <div className="content-portafolio">
                <div className="cont-portafolio-table">
                  <div className="content-card-portafolio" id="content">
                    {(loadingHost || loadingList) ? (
                      <LoadSimple />
                    ) : (
                      <>
                        {cisSelected.length === 0 ? (
                          <TableWorkFlow
                            pageActual={pageActual}
                            limitList={limitList} startLimit={startLimit}
                            dataList={dataList}
                            cisSelected={cisSelected}
                            setCisSelected={setCisSelected}
                            registerIsValid={registerIsValid}
                            searchResults={searchResults}
                            setSearchResults={setSearchResults}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            dataUsers={dataUsers}
                            setDataUsers={setDataUsers}
                            server={server}
                            setRegisterIsValid={setRegisterIsValid}
                            setData={setData}
                            setLoading={setLoading}
                            setError={setError}
                            handleChangEdit={handleChangEdit}
                            devices={devices}
                            languaje={languaje}
                            mode={mode}
                            setContRowSelected={setContRowSelected}
                            poolRows={poolRows}
                            setPoolRows={setPoolRows}
                            allSelected={allSelected}
                            setAllSelected={setAllSelected}
                            handleShowPopup={handleShowPopup}
                            buscar_cis={buscar_cis}
                            loadingList={loadingList}
                            userPermissions={userPermissions}
                          ></TableWorkFlow>
                        ) : (
                          ("")
                          // <InfoPortafolio
                          //   server={server}
                          //   portfolioSelected={cisSelected}
                          //   searchResults={searchResults}
                          //   setSearchResults={setSearchResults}
                          //   searchTerm={searchTerm}
                          //   setSearchTerm={setSearchTerm}
                          //   onSearch={handleSearch}
                          //   dataUsers={dataUsers}
                          //   setDataUsers={setDataUsers}
                          //   setCisSelected={setCisSelected}
                          //   registerIsValid={registerIsValid}
                          // ></InfoPortafolio>
                        )}
                      </>
                    )}
                  </div>
                </div>

              </div>
              <div className={"content-portafolio-footer" + mode}>
                <div className="cont-display-paginador" style={{ position: 'absolute', left: '0%', justifyContent: 'start' }}>

                  <div className={"cont-half-display-paginador" + mode}>
                    <p style={{ textAlign: "center" }}>
                      &nbsp;
                      {(contRowsSelected != 0) ? "(" + contRowsSelected + ")  " + capitalizeFirstLetter(lang[languaje]['registosSeleccionados']) : ''}
                    </p>

                  </div>
                </div>
                <div className="cont-display-paginador">
                  <Paginador pages={pages}
                    pageActual={pageActual}
                    setPageActual={setPageActual}
                    mode={mode}></Paginador>
                </div>
                <div className="cont-display-paginador">
                  <div className={"cont-half-display-paginador" + mode}>

                    <div>
                      <label htmlFor="selector">{capitalizeFirstLetter(lang[languaje]['filasPagina'])}: </label>
                      <select id="selector" value={limitList} className="pageSelector" onChange={handleSelectChange}>
                        <option value={10}>10</option>
                        <option value={50} >50</option>
                        <option value={100}>100</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                      </select>


                    </div>
                  </div>
                  <div className={"cont-half-display-paginador" + mode}>
                    <p style={{ textAlign: "center" }}>
                      &nbsp;
                      {"(" +
                        (startLimit + 1) +
                        " - " +
                        (dataList.length > parseInt(pageActual) * parseInt(limitList)
                          ? parseInt(pageActual) * parseInt(limitList)
                          : dataList.length) +
                        ")  " + lang[languaje]['de'] + " " +
                        dataList.length +
                        " " + lang[languaje]['resultados']}
                    </p>

                  </div>
                </div>

              </div>
            </div>
          </div>
          <Modal
            isOpen={CreateCisModalOpen}
            // isOpen={false}
            // onAfterOpen={afterOpenExeption}
            onRequestClose={closCreateCisModal}
            style={page ? CreateCisModalStyles2 : CreateCisModalStyles}
            contentLabel="Example Modal2"
          // shouldCloseOnOverlayClick={false}
          >
            <ModalCreateWorkFlow
              devices={devices}
              hosts={hosts}
              server={server}
              editActive={editActive}
              setEditActive={setEditActive}
              dataCis={dataCis}
              setData={setData}
              loading={loading}
              setLoading={setLoading}
              setError={setError}
              dataUsers={dataUsers}
              setRegisterIsValid={setRegisterIsValid}
              closCreateCisModal={closCreateCisModal}
              groupSelected={groupSelected}
              languaje={languaje}
              mode={mode}
              setSearchTerm={setSearchTerm}
              handleShowPopup={handleShowPopup}
              buscar_cis={buscar_cis}
              page={page}
              setPage={setPage}
            ></ModalCreateWorkFlow>
          </Modal>

          {/* <Modal
  isOpen={ImportModalOpen}
  // isOpen={false}
  // onAfterOpen={afterOpenExeption}
  onRequestClose={closeImportModal}
  style={ImportModalStyles}
  contentLabel="Example Modal2"
  shouldCloseOnOverlayClick={false}
>
<ImportInfo
server={server}
importLoading={importLoading}
setImportLoading={setImportLoading}
closeImportModal={closeImportModal}
languaje={languaje}
mode={mode}
handleShowPopup={handleShowPopup}
></ImportInfo>
</Modal> */}
        </>

      </div>
    </>
  );
};

export default PanelWorkFlow;
